<template>
    <div class="header ">
        <div class="ydShow" style="height: 67px "></div>
      
        <div class="header-device-mobile ydShow header_top" ref="elementTop2">
            <!-- <img src="https://boshi2023.oss-cn-shanghai.aliyuncs.com/H5_img/icon16.png" alt="img" class="icon16"> -->
            <img src="https://boshi2023.oss-cn-shanghai.aliyuncs.com/H5_img/icon16.gif" alt="img" class="icon16">
            <div class="wapper">
                <div class="item mobile-logo pointer" >
                    <div class="logo">
                        <svg class="icon-logo">
                            <use xlink:href="#icon-logo"></use>
                        </svg>
                    </div>
                </div>
                <div class="flex1"></div>
               
            </div>
        </div>
    </div>
</template>

<script>

import SvgIcon from "@/components/svgIcon/index.vue"
import "@/components/svgIcon/svg.js" // 批量导入svg文件
import { EventBus } from "../main"
export default {
    components: {
        SvgIcon
    },
    name: 'Header',
    props: {
        msg: String
    },
    data() {
        return {
            nav: 1,
        }
    },
    watch: {
        $route(to, from, next) {
            var that = this
        },
    },
    created() {
        var that = this
        
    },
    mounted() {
        var that = this
    },
    methods: {
       
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.header-control {
    position: relative;
    left: 6px;
}

.pcShow .nav-d {
    padding-top: 10px;
    margin-left: -20px;
}

.AutoParts {
    font-weight: bolder;
    align-self: flex-end;
    padding-bottom: 10px;
    color: #000;
}

.nav-item {
    flex: initial;

}

.nav-item div {
    padding: 10px 20px;
}

.nav-item:hover {
    color: #007BBF;

}

.headerH {
    padding-top: 20px;
    // padding: 20px 0;
}

.scrollTop {
    animation-name: paddingChange;
    animation-duration: 0.5s;
    /* 动画持续时间 */
    animation-fill-mode: forwards;
    /* 动画结束后保持最后一帧的样式 */
    animation-timing-function: ease-out;
    padding: 50px 0;
}

@keyframes paddingChange {
    from {
        padding: 50px 0;
    }

    to {
        padding: 20px 0;
    }
}

.scrollbom {
    animation-name: paddingChange2;
    animation-duration: 0.1s;
    /* 动画持续时间 */
    animation-fill-mode: forwards;
    /* 动画结束后保持最后一帧的样式 */
    animation-timing-function: ease;
    padding: 20px 0;
}

@keyframes paddingChange2 {
    from {
        padding: 20px 0;
    }

    to {
        padding: 50px 0;
    }
}

.header_top {
    position: fixed;
    // position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
}

.icon {
    width: 1em;
    height: 1em;
    fill: currentColor;
    vertical-align: -0.15em;
}

.svg-icon {
    width: 1em;
    height: 1em;
    fill: currentColor;
    vertical-align: -0.15em;
}

.mobile-logo {
    width: 118px;
    height: auto;
}

.country_no {
    color: #000;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: bold;
}

.header {
    background: #fff;
}

.switch_nav_d {
    position: fixed;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    z-index: 9999;
    pointer-events: auto;
}

.switch_nav_bg {
    padding-top: 10px;
    width: 100%;
    flex: 1;
    background: #fff;

}

.switch_li {
    height: 66px;
    padding: 0 18px;
    box-sizing: border-box;
    border-bottom: 1px solid #F2F2F2;

}

.icon21 {
    width: 7px;
    height: auto;
}
</style>
